import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SetAvailabilityRequest } from 'happypaws-shared/src/Sitter/models/SetAvailabilityRequest';
import { api } from '../../services/api';

export const useSetAvailability = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SetAvailabilityRequest) => {
      await api.post('/sitters/availability', data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['sitterProfile'] });
    },
  });
};
